// extracted by mini-css-extract-plugin
module.exports = {"SubHeading":"CardDetailsModal_SubHeading__3XZAl","Members":"CardDetailsModal_Members__3ucCI"};